import axios from "axios";
import { API_BASE_URL } from "../config/constants";

class DestinationModel {
    constructor() {
        const storedData = JSON.parse(localStorage.getItem("destinationData")) || [];
        this._destinations = storedData;

        if (this._destinations.length === 0) {
            this.initializeFromAPI();
        }
    }

    async initializeFromAPI() {
        try {
            const response = await axios.get(`${API_BASE_URL}destination`);

            if (Array.isArray(response.data.data) && response.data.data.length > 0) {
                this._destinations = response.data.data.map(dest => ({
                    id: dest.PK_DESTINATION_NAME,
                    name: dest.PK_DESTINATION_NAME,
                    distance: dest.DESTINATION_DISTANCE,
                    runningTime: dest.RUNNING_TIME,
                    highRangeArea: dest.HIGH_RANGE_AREA,
                    tollCharge: dest.TOLL_CHARGE,
                    tollDescription: dest.TOLL_DESCRIPTION,
                    status: dest.STATUS,
                    permitRequired: dest.TPERMIT
                }));
                
                this._destinations.sort((a, b) => a.name.localeCompare(b.name));

                this._saveToLocalStorage();
            } else {
                console.warn("No destinations found in API response.");
            }
        } catch (error) {
            console.error("Error fetching destination data:", error);
        }
    }

    getDestinations() {
        return this._destinations;
    }

    getDistanceByName(destinationName) {
        const destination = this._destinations.find(dest => dest.name === destinationName);
        if (destination) {
            return destination.distance;
        } else {
            console.warn(`Destination with name "${destinationName}" not found.`);
            return null;
        }
    }
    getTollByName(destinationName) {
        const destination = this._destinations.find(dest => dest.name === destinationName);
        if (destination) {
            return destination.tollCharge;
        } else {
            console.warn(`Destination with name "${destinationName}" not found.`);
            return null;
        }
    }

    _saveToLocalStorage() {
        localStorage.setItem("destinationData", JSON.stringify(this._destinations));
    }
}

export default new DestinationModel();